import { Selector } from 'react-redux';
import { RootState } from '../../redux/root-reducer';
import { createSelector } from 'reselect';
import { IActivityInitialState, ICursor, IFeedFilter, IFeedSuggestion, ITimeline } from '../../redux/activity/types';
import { IManageProjectResponse } from '../../types/global/manageProject.types';
import { projectSelector } from '../UserProjects/selector';

export const feedStateSelector: Selector<RootState, IActivityInitialState> = createSelector(
    (state: RootState) => state.activity,
    activity => activity,
);

export const activityFeedSelector: Selector<RootState, ITimeline> = createSelector(
    [feedStateSelector],
    feed => feed.timeline,
);

export const feedSuggestionSelector: Selector<RootState, IFeedSuggestion | undefined> = createSelector(
    [feedStateSelector],
    suggestion => suggestion.feedSuggestion,
);

export const bookmarkingSelector: Selector<RootState, boolean | undefined> = createSelector(
    [feedStateSelector],
    feed => feed.bookmarking,
);

export const filterSelector: Selector<
    RootState,
    {
        filters?: IFeedFilter[];
        fetching?: boolean;
        fetchingTimeline?: boolean;
        nextCursor?: ICursor | null;
        firstCursor: ICursor[];
    }
> = createSelector([feedStateSelector], feed => {
    return {
        filters: feed.filters,
        fetching: feed.fetchingFilters,
        fetchingTimeline: feed.fetchingTimeline,
        nextCursor: feed.nextCursor,
        firstCursor: feed.firstCursor,
    };
});

interface IManagedProjectSelector {
    project?: IManageProjectResponse;
    loading?: boolean;
    replacingInProgress?: boolean;
}
export const managedProjectSelector: Selector<RootState, IManagedProjectSelector> = createSelector(
    [projectSelector],
    project => ({
        project: project.currentlyManagedProject,
        loading: project.gettingProjectToManage,
        replacingInProgress: project.replacingInProgress,
    }),
);
